import fetch from "utils/fetch";

export const fetchServers = ({ params, ...rest }) => {
  return fetch({
    url: `/servers`,
    method: "GET",
    params,
    ...rest
  });
};
